export enum EnumBooleanDigitized {
  FALSE = "0",
  TRUE = "1",
}
